import * as React from 'react';

const FilterSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="filter_svg__eds-icon--filter_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="filter_svg__eds-icon--filter_bottom"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 20h1v-3H9v3zm-1-4v2H4v1h4v2h3v-2h9v-1h-9v-2H8z"
        />
        <path
            id="filter_svg__eds-icon--filter_middle"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18 13.5h1v-3h-1v3zm-1-4v2H4v1h13v2h3v-5h-3z"
        />
        <path
            id="filter_svg__eds-icon--filter_top"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 7h1V4H9v3zM8 3v2H4v1h4v2h3V6h9V5h-9V3H8z"
        />
    </svg>
);

FilterSvg.displayName = 'FilterSvg';
export default FilterSvg;
